import { ofType } from "redux-observable";
import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { FETCH_SEARCHABLE_BEGIN, fetchSearchableSuccess, logError } from "../actions";
import sources from "../utils/JsonSources";
import { getAjaxSettings } from "../utils/getAjaxSettings";
export default function fetchSearchableSlidesEpic(action$, state$) {
    return action$.pipe(ofType(FETCH_SEARCHABLE_BEGIN), mergeMap(function(action) {
        return ajax(getAjaxSettings(sources.searchPrintPath, state$.value)).pipe(switchMap(function(param) {
            var response = param.response;
            return [
                fetchSearchableSuccess({
                    slides: response
                })
            ];
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "fetch_searchable_slides"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "fetch_searchable_slides"
        }));
    }));
}
